import * as React from 'react';

interface RouterProps {
  location: any;
  router: any;
  routeParams: any;
}

const connectRouterChange = (fetcher: (props: any, prevProps: any) => void) =>
  <TProps extends RouterProps>(Component: React.ComponentClass<TProps>, name?: string) => {

    const result = class Connected extends React.Component<TProps, null> {
      static displayName = `connectRouterChange(${name})`;

      componentDidMount() {
        fetcher(this.props, null);
      }

      componentDidUpdate(prevProps) {
        fetcher(this.props, prevProps);
      }

      render() {
        return <Component {...this.props} />;
      }
    };

    return result;
  };

export default connectRouterChange;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/connect_router_change.tsx